var vars = require('./core');

module.exports = vars.createClass('Bar', ['getBarsAtEvent']);



// WEBPACK FOOTER //
// ./src/Scripts/react-chartjs/lib/bar.js